import { render, staticRenderFns } from "./CompanyTobaEdit.vue?vue&type=template&id=beb0f6fa&scoped=true&"
import script from "./CompanyTobaEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyTobaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb0f6fa",
  null
  
)

export default component.exports